import script from "./SidePanelFields.vue?vue&type=script&setup=true&lang=js"
export * from "./SidePanelFields.vue?vue&type=script&setup=true&lang=js"

import "./SidePanelFields.vue?vue&type=style&index=0&id=0ac48ed6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ac48ed6"]])

export default __exports__